var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ClipLoader',{attrs:{"loading":_vm.loading,"color":_vm.loaderColor,"size":_vm.size}})
}
var staticRenderFns = []

export { render, staticRenderFns }